var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-component",class:[
        ("size-" + _vm.size)
      ]},[(_vm.title)?_c('h1',{staticClass:"card-header"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),(_vm.icon)?_c('ym-icon',{staticClass:"icon-tick-round ym-icon",attrs:{"name":_vm.icon}}):_vm._e()],1):_vm._e(),_c('div',{staticClass:"card-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }